export default __webpack_public_path__ + "static/media/image-keyboard.bd0aeeaf.jpg";